"use client";

import {Block} from "@/shared/strapiTypes/common/Blocks";
import {FCWithHTMLAttributes} from "../types/reactTypes";
import GenericOverlayModal from "./GenericOverlayModal";
import {useEffect, useState} from "react";
import getSummerCampsModalFeatureFlagValue from "../util/getSummerCampsModalFeatureFlagValue";

export interface GenericOverlayModalClientWrapperProps {
	attributes: {
		title?: string;
		bodyContent?: Block[];
		buttonText?: string;
		buttonLink?: string;
		buttonId?: string;
		localStorageFieldName?: string;
	};
}

const GenericOverlayModalClientWrapper: FCWithHTMLAttributes<
	GenericOverlayModalClientWrapperProps
> = ({attributes}) => {
	const [hasSeenModal, setHasSeenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [summerCampsModalEnabled, setSummerCampsModalEnabled] = useState(false);

	useEffect(() => {
		const setSummerCampsModalEnabledStateValue = async () => {
			const summerCampsModalFlagValue =
				await getSummerCampsModalFeatureFlagValue();
			const summerCampsModalEnabledValue = !!summerCampsModalFlagValue;
			setSummerCampsModalEnabled(summerCampsModalEnabledValue);
		};
		setSummerCampsModalEnabledStateValue();
		const localStorageValue = attributes.localStorageFieldName
			? window.localStorage.getItem(attributes.localStorageFieldName)
			: false;
		const hasSeenModalValue =
			localStorageValue && localStorageValue === "true" ? true : false;
		setHasSeenModal(hasSeenModalValue);
		setIsLoading(false);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
	return (
		!isLoading &&
		summerCampsModalEnabled && (
			<GenericOverlayModal startOpen={!hasSeenModal} {...attributes} />
		)
	);
};

export default GenericOverlayModalClientWrapper;
